import { create } from 'zustand';
import { emptySession, GameSettings, SessionState } from '../types';
import * as sessionApi from '../services/sessionApi';

interface SessionStore {
  session: SessionState;
  applySession: (session: SessionState) => void;
  startPackage: (packageId: string) => Promise<void>;
  playNumber: (number: number) => Promise<void>;
  stopPlayback: () => Promise<void>;
  trackEnded: () => Promise<void>;
  dontStop: () => Promise<void>;
  resumePaused: () => Promise<void>;
  setHidePlayed: (hidePlayed: boolean) => Promise<void>;
  resetGame: () => Promise<void>;
  endGame: () => Promise<void>;
  updateSettings: (settings: Partial<GameSettings>) => Promise<void>;
  reportPosition: (currentTime: number) => Promise<void>;
}

/** Store зеркала серверной игровой сессии. */
export const useSessionStore = create<SessionStore>((set) => ({
  session: emptySession(),

  applySession: (session) => set({ session }),

  startPackage: async (packageId) => {
    set({ session: await sessionApi.startPackage(packageId) });
  },
  playNumber: async (number) => {
    set({ session: await sessionApi.playNumber(number) });
  },
  stopPlayback: async () => {
    set({ session: await sessionApi.stopPlayback() });
  },
  trackEnded: async () => {
    set({ session: await sessionApi.trackEnded() });
  },
  dontStop: async () => {
    set({ session: await sessionApi.dontStop() });
  },
  resumePaused: async () => {
    set({ session: await sessionApi.resumePaused() });
  },
  setHidePlayed: async (hidePlayed) => {
    set({ session: await sessionApi.setHidePlayed(hidePlayed) });
  },
  resetGame: async () => {
    set({ session: await sessionApi.resetGame() });
  },
  endGame: async () => {
    set({ session: await sessionApi.endGame() });
  },
  updateSettings: async (settings) => {
    set({ session: await sessionApi.updateSettings(settings) });
  },
  reportPosition: async (currentTime) => {
    set({ session: await sessionApi.reportPosition(currentTime) });
  },
}));
